import { FormattedMessage, useIntl } from "react-intl"
import React, { ReactElement } from "react"
import { Card, Button, SurfaceColor, Stack, Tile, useTheme } from "@carrotfertility/carotene-core"
import { ProgramType } from "#/lib/carrot-api/types/Benefit"
import { DbgPaths } from "#/utils/Paths"
import { useBenefitHighlights } from "./hooks/useBenefitHighlights"
import { BenefitHighlightsInner } from "#/components/home/benefits-modules/BenefitHighlightInnerContent"
import { useContentfulBenefitHighlights } from "./hooks/useContentfulBenefitHighlights"
import { ContentfulContentRenderer } from "#/services/contentful"

export function BenefitHighlightsCard({ color = "blue" }: { color?: SurfaceColor }): ReactElement {
  const intl = useIntl()
  const { isBenefitLoading, programTypeAllowsBenefitHighlight, filteredValueProps, programType } =
    useBenefitHighlights()

  if (isBenefitLoading || !programTypeAllowsBenefitHighlight) {
    return null
  }

  return (
    <Card
      variant="secondary"
      color={color}
      id="benefit-highlights-sidebar"
      title={intl.formatMessage({
        defaultMessage: "Benefit highlights"
      })}
      primaryAction={
        programType === ProgramType.PRO && (
          <Button
            variant="outlined"
            color="secondary"
            href={DbgPaths.CARROT_ELIGIBLE}
            component="a"
            sx={{
              // eslint-disable-next-line prettier/prettier
              justifyContent: 'center',
              textAlign: "center"
            }}
          >
            <FormattedMessage defaultMessage="Learn to use Carrot funds" />
          </Button>
        )
      }
    >
      <BenefitHighlightsInner filteredValueProps={filteredValueProps} color={color} />
    </Card>
  )
}

export function ContentfulBenefitHighlightsTile({ color = "blue" }: { color?: SurfaceColor }): ReactElement {
  const theme = useTheme()
  const { content, programTypeAllowsBenefitHighlight, isLoading, isError } = useContentfulBenefitHighlights()

  if (isLoading || isError || !content || !programTypeAllowsBenefitHighlight) {
    return null
  }

  return (
    <Tile id="contentful-benefit-highlights-sidebar" variant="secondary" color={color}>
      <Stack spacing={theme.spacing(theme.tokens.spacing.md)}>
        <ContentfulContentRenderer contents={content} />
      </Stack>
    </Tile>
  )
}
